export const GENERAL_EXPENSE_TYPE_OPTIONS = ["office", "general", "vehicle", "driver"];

export const initialGeneralExpenseForm = {
  expenseType: "general",
  vehicleId: "",
  driverId: "",
  amount: "",
  description: "",
  receipt: "",
  expenseDate: "",
};

export const normalizeGeneralExpenses = (data) => {
  if (Array.isArray(data)) return data;
  return data?.generalExpenses || data?.expenses || data?.items || [];
};

export const filterGeneralExpenses = (expenses, searchTerm) => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return expenses;

  return expenses.filter((expense) => {
    const expenseType = expense?.expenseType?.toLowerCase() || "";
    const description = expense?.description?.toLowerCase() || "";
    const amount = String(expense?.amount || "").toLowerCase();

    return expenseType.includes(term) || description.includes(term) || amount.includes(term);
  });
};

export const formatGeneralExpenseDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  return new Intl.DateTimeFormat("en-PK", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  }).format(date);
};

export const formatGeneralExpenseAmount = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "-";

  return new Intl.NumberFormat("en-PK", {
    style: "currency",
    currency: "PKR",
    maximumFractionDigits: 0,
  }).format(amount);
};

export const mapGeneralExpenseToForm = (expense) => ({
  expenseType: expense?.expenseType || "general",
  vehicleId:
    (typeof expense?.vehicleId === "object" ? expense?.vehicleId?._id : expense?.vehicleId) || "",
  driverId:
    (typeof expense?.driverId === "object" ? expense?.driverId?._id : expense?.driverId) || "",
  amount: expense?.amount !== undefined && expense?.amount !== null ? String(expense.amount) : "",
  description: expense?.description || "",
  receipt: expense?.receipt || "",
  expenseDate: expense?.expenseDate ? String(expense.expenseDate).slice(0, 10) : "",
});

export const validateGeneralExpenseForm = (form) => {
  const errors = {};
  const normalizedExpenseType = (form.expenseType || "").trim().toLowerCase();

  if (!normalizedExpenseType) {
    errors.expenseType = "Expense type is required.";
  } else if (!GENERAL_EXPENSE_TYPE_OPTIONS.includes(normalizedExpenseType)) {
    errors.expenseType = "Please select a valid expense type.";
  }

  if (normalizedExpenseType === "vehicle" && !form.vehicleId) {
    errors.vehicleId = "Vehicle is required for vehicle expense type.";
  }

  if (normalizedExpenseType === "driver" && !form.driverId) {
    errors.driverId = "Driver is required for driver expense type.";
  }

  if (!form.amount || Number(form.amount) <= 0) {
    errors.amount = "Amount must be greater than 0.";
  }

  return errors;
};

export const buildGeneralExpensePayload = (form) => ({
  expenseType: (form.expenseType || "").trim().toLowerCase(),
  vehicleId: form.expenseType === "vehicle" ? form.vehicleId : null,
  driverId: form.expenseType === "driver" ? form.driverId : null,
  amount: Number(form.amount),
  description: form.description.trim(),
  receipt: form.receipt?.trim() || null,
  expenseDate: form.expenseDate || null,
});
